import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";

const API_URL = process.env.REACT_APP_API_URL;

export default function useAuthUser() {
  const {
    data: authUser,
    isPending,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["auth"],
    queryFn: async () => {
      const res = await fetch(`${API_URL}/auth/me`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("gameport")}`,
        },
      });

      const data = await res.json();

      if (!res.ok) {
        
        return null;
      }

      if (data?.error) return null;

      return data;
    },
    retry: false,
  });

  return {
    authUser,
    isPending,
    isLoading,
    isError,
  };
}
